var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { set, computed } from '@ember/object';
import { join } from '@ember/runloop';
import Component from '@ember/component';
import { TextField } from 'field-kit'; // eslint-disable-line import/named
import ValidatedViewSupport from '@dashboard/shared-ui/mixins/validated-view-support'; // eslint-disable-line ember/no-mixins

// Since this component isn't meant to be implemented directly it does not have a template
// Example of what to put in the template:
// <Input class="input" placeholder={{@placeholder}} />
//
// FIXME (steckel): It would be more correct to have this element render an
// input element **directly**. Using a custom element of <sq-input> and have it
// render a <div> tag is counter intuitive and forces one to set work around the
// surrounding div element through a public variable of `inputClassNames` which
// leaks its internals.
let SqInputFormatted = (_class = class SqInputFormatted extends Component.extend(ValidatedViewSupport) {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "field", null);
    _defineProperty(this, "inputClassNames", null);
    _defineProperty(this, "_storedValue", null);
  }
  // These functions can be overridden by child components.
  valueToStore(value) {
    return value;
  }
  valueToShow(value) {
    return value;
  }
  textFieldDidEndEditing() {
    join(() => {
      // Trigger value recomputation
      // _setFieldValue may cause the this.field.value() to change
      const oldValue = this.field.value();
      this._setFieldValue(oldValue);
      const newValue = this.field.value();
      this.set('value', this.valueToStore(newValue));
      this.onChange?.(newValue);
    });
  }
  set value(value = null) {
    if (this.field) {
      this._setFieldValue(value);
    }
    this._storedValue = value;
  }
  get value() {
    return this._storedValue ?? this.field?.value();
  }
  _getFormatter() {
    return null;
  }
  _getField() {
    const inputElement = this.element.querySelector('input');
    return new TextField(inputElement);
  }
  _setFieldValue(value) {
    // without this check, fields with a value binding trigger a
    // @value() and thus a @_setFieldValue call on keyup.
    // This is problematic because it resets the selection range,
    // sending the caret to the end of the field.
    const valueToShow = this.valueToShow(value);
    if (this.field.text() !== this.field.formatter().format(valueToShow)) {
      this.field.setValue(valueToShow);
    }
  }
  didUpdateAttrs() {
    super.didUpdateAttrs();
    this.field.setFocusedPlaceholder(this.focusedPlaceholder);
    this.field.setUnfocusedPlaceholder(this.unfocusedPlaceholder);
  }
  didInsertElement() {
    super.didInsertElement();
    const field = this._getField();
    set(this, 'field', field);
    if (this._getFormatter()) {
      field.setFormatter(this._getFormatter());
    }
    field.setDelegate(this);
    field.setFocusedPlaceholder(this.focusedPlaceholder);
    field.setUnfocusedPlaceholder(this.unfocusedPlaceholder);
    this._setFieldValue(this._storedValue);
  }
  willDestroyElement(...args) {
    super.willDestroyElement(...args);
    this.field.destroy();
  }
}, _applyDecoratedDescriptor(_class.prototype, "value", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "value"), _class.prototype), _class);
export { SqInputFormatted as default };